<template>
  <div class="additional-information">
    <div class="information-section">
      <div class="container">
        <div class="accordion-section" :class="{ active: isRelationshipActive }" id="relationship-accordion">
          <a class="accordion-tooltip"
            href="#" @click.prevent="isRelationshipActive ? closeAccordion(RELATIONSHIP) : openAccordion(RELATIONSHIP)">
          <div :class="{selected: chosenRelationshipType}" class="accordion-text-cell table-cell-vmid">
            ¿Cuál es tu estado civil?
            </div>
            <div class="table-cell-vmid">
              <div alt="Dropdown Icon" class="accordion-dropdown-icon"></div>
            </div>
          </a>
          <div class="accordion-animation-padding">
            <div class="accordion-content">
              <ul class="accordion-content-list relationship-status">
                <li v-for="(item) in relationshipTypes" :key="item.key" @click="relationshipTypeChosen(item.key)" :class="{selected: chosenRelationshipType === item.key}">{{item.value}}</li>
              </ul>
            </div>
          </div>
        </div>
        <div class="accordion-section" :class="{ active: isWorkTypeActive }" id="dependancy-type-accordion">
          <a class="accordion-tooltip"
            href="#" @click.prevent="isWorkTypeActive ? closeAccordion(WORK_TYPE) : openAccordion(WORK_TYPE)">
          <div :class="{selected: chosenDependancy}" class="accordion-text-cell table-cell-vmid">
            ¿Trabajás en Relación de Dependencia?
            </div>
            <div class="table-cell-vmid">
              <div alt="Dropdown Icon" class="accordion-dropdown-icon"></div>
            </div>
          </a>
          <div class="accordion-animation-padding">
            <div class="accordion-content">
              <ul class="accordion-content-list work-types">
                <li v-for="(item) in dependancyRelationship" :key="item.key" @click="dependancyRelationshipChosen(item.key)" :class="{selected: chosenDependancy === item.key}">{{item.value}}</li>
              </ul>
            </div>
          </div>
        </div>
        <div class="accordion-section" :class="{ active: isWorkIndustryActive, hidden: (chosenDependancy !== 'YES'  && chosenDependancy !== 'NO_INDEPENDENT' && chosenDependancy !== '') }" id="dependancy-accordion">
          <a class="accordion-tooltip"
            href="#" @click.prevent="isWorkIndustryActive ? closeAccordion(WORK_INDUSTRY) : openAccordion(WORK_INDUSTRY)">
          <div :class="{selected: chosenJobs.length > 0}" class="accordion-text-cell table-cell-vmid">
            {{activityTypeTitle}} <span class="accordion-link" v-if="chosenJobs.length > 0"><br>Agregar +</span>
            </div>
            <div class="table-cell-vmid">
              <div alt="Dropdown Icon" class="accordion-dropdown-icon"></div>
            </div>
          </a>
          <div class="accordion-animation-padding">
            <div class="accordion-content">
              <ul class="accordion-content-list jobs-chosen">
                <li class="selected" v-for="(value, index) in chosenJobs" :key="index">{{jobChoices.filter(i => i.id === value)[0].name}} <button @click="deleteJob(value)" class="del">X</button></li>
              </ul>
              <input id="job-search-field" class="accordion-input-fields" placeholder="Buscar..."
                type="text" v-model="jobSearchField" />
              <ul class="accordion-content-list work-industries">
                <li v-for="(item, index) in filteredJobChoices" :key="index" @click="jobChosen(item.id)">{{item.name}}</li>
              </ul>
            </div>
          </div>
        </div>
        <div class="accordion-section" :class="{ active: isPEPActive }" id="pep-accordion">
          <a class="accordion-tooltip"
            href="#" @click.prevent="isPEPActive ? closeAccordion(PEP) : openAccordion(PEP)">
          <div :class="{selected: chosenPep}" class="accordion-text-cell table-cell-vmid">
            ¿Sos Persona Expuesta Políticamente (PEP)?
            </div>
            <div class="table-cell-vmid">
              <div alt="Dropdown Icon" class="accordion-dropdown-icon"></div>
            </div>
          </a>
          <div class="accordion-animation-padding">
            <div class="accordion-content">
              <ul class="accordion-content-list pep-options">
                <li v-for="(item) in pepChoices" :key="item.key" @click="pepChosen(item.key)" :class="{selected: chosenPep === item.key}">{{item.value}}</li>
              </ul>
              <p style="margin-top: 20px;font-size: 11px;">¿No sabés qué es PEP? <span @click="showPepModal = !showPepModal" class="help-text">Hacé click acá</span></p>
            </div>
          </div>
        </div>
        <div class="accordion-section" :class="{ active: isFiscalCountryActive }" id="fiscal-country-accordion">
          <a class="accordion-tooltip"
            href="#" @click.prevent="isFiscalCountryActive ? closeAccordion(FISCAL_COUNTRY) : openAccordion(FISCAL_COUNTRY)">
          <div :class="{selected: Object.entries(chosenFiscalCountries).length !== 0 && chosenFiscalCountries.constructor === Object}" class="accordion-text-cell table-cell-vmid">
            ¿Cuál es tu País de Residencia Fiscal?  <span class="accordion-link" v-if="Object.entries(chosenFiscalCountries).length !== 0 && chosenFiscalCountries.constructor === Object"><br>Agregar +</span>
            </div>
            <div class="table-cell-vmid">
              <div alt="Dropdown Icon" class="accordion-dropdown-icon"></div>
            </div>
          </a>
          <div class="accordion-animation-padding">
            <div class="accordion-content">
              <ul class="accordion-content-list fiscal-countries-chosen">
                <li class="selected" v-for="(value, key) in chosenFiscalCountries" :key="key">{{countryChoices.filter((i) => i.code === Number(key))[0].name}} - {{value}}  <button @click="deleteFiscalCountry(key)" class="del">X</button></li>
              </ul>
              <input id="country-search-field" class="accordion-input-fields" placeholder="Buscar..."
                type="text" v-model="countrySearchField" />
              <ul class="accordion-content-list fiscal-countries">
                <!-- :class="{selected: item.code in chosenFiscalCountries}" -->
                <li v-for="(item) in filteredCountryChoices" :key="item.code" @click="fiscalCountryChosen(item.code)">{{item.name}}</li>
              </ul>
            </div>
          </div>
        </div>
        <div class="accordion-section" :class="{ active: isCellPhoneActive }" id="cellphone-accordion">
          <a class="accordion-tooltip"
            href="#" @click.prevent="isCellPhoneActive ? closeAccordion(CELL_PHONE) : openAccordion(CELL_PHONE)">
          <div :class="{selected: getCompletedCellphone}" class="accordion-text-cell table-cell-vmid">
            Completá tu Celular de Contacto
            </div>
            <div class="table-cell-vmid">
              <div alt="Dropdown Icon" class="accordion-dropdown-icon"></div>
            </div>
          </a>
          <div class="accordion-animation-padding">
            <div class="accordion-content telephone-content">
              <input id="cellphone-code-field" class="accordion-input-fields cellphone-fields" @keypress="isNumber($event)"
                placeholder="Cod. Area" type="text" v-model="cellphoneCode" :maxlength="maxLengthCellphoneCode" />
              <input id="cellphone-number-field" class="accordion-input-fields cellphone-fields" @keypress="isNumber($event)"
                placeholder="Número" type="text" v-model="cellphoneNumber" :maxlength="maxLengthCellphone" />
            </div>
          </div>
        </div>
        <div class="accordion-section" id="terms-accordion">
          <input id="terms-and-conditions" name="terms-and-conditions" type="checkbox" v-model="acceptedTermsAndCondition">
          <label>Acepto los <span @click="showTermsModal = !showTermsModal" class="help-text" style="font-size: 16px;">términos y condiciones</span></label>
        </div>
      </div>
    </div>
    <Modal headerText="¿Qué es una PEP?" v-if="showPepModal"
      @close="showPepModal = !showPepModal">
      <div class="modal-body-container" slot="body">
        <p style="text-align: left; font-size: 11px;">
          Según la resolución 134/2018 de la UIF, son PEP:<br>
          ARTÍCULO 1º.- PERSONAS EXPUESTAS POLITICAMENTE EXTRANJERAS.<br>
          a. Jefe de Estado, jefe de Gobierno, Gobernador, Intendente, Ministro, Secretario, Subsecretario de Estado u otro cargo gubernamental equivalente.<br>
          b. Miembro del Parlamento, Poder Legislativo, o de otro órgano de naturaleza equivalente.<br>
          c. Juez, Magistrado de Tribunales Superiores u otra alta instancia judicial, o administrativa, en el ámbito del Poder Judicial.<br>
          d. Embajador o cónsul, de un país u organismo internacional.<br>
          e. Autoridad, apoderado, integrantes del órgano de administración o control y miembros relevantes de partidos políticos extranjeros.<br>
          f. Oficial de alto rango de las fuerzas armadas (a partir de coronel o grado equivalente en la fuerza y/o país de que se trate) o de las fuerzas de seguridad pública (a partir de comisario o rango equivalente según la fuerza y/o país de que se trate).<br>
          g. Miembro de los órganos de dirección y control de empresas de propiedad estatal.<br>
          h. Miembro de los órganos de dirección o control de empresas de propiedad privada o mixta; cuando el Estado posea una participación igual o superior al VEINTE POR CIENTO (20%) del capital o del derecho a voto, o ejerza de forma directa o indirecta el control de la compañía.<br>
          i. Director, gobernador, consejero, síndico o autoridad equivalente de bancos centrales y otros organismos de regulación y/o supervisión.<br>
          j. Director, subdirector; miembro de la junta, directorio, alta gerencia, o cargos equivalentes, apoderados, representantes legales o autorizados, de una organización internacional, con facultades de decisión, administración o disposición.<br>
          <br>
          ARTÍCULO 2º.- PERSONAS EXPUESTAS POLITICAMENTE NACIONALES.<br>
          a. Presidente o Vicepresidente de la Nación.<br>
          b. Senador o Diputado de la Nación.<br>
          c. Magistrado del Poder Judicial de la Nación.<br>
          d. Magistrado del Ministerio Público de la Nación.<br>
          e. Defensor del Pueblo de la Nación o Defensor del Pueblo Adjunto.<br>
          f. Jefe de Gabinete de Ministros, Ministro, Secretario o Subsecretario del Poder Ejecutivo Nacional.<br>
          g. Interventor federal, o colaboradores del interventor federal con categoría no inferior a Director o su equivalente.<br>
          h. Síndico General de la Nación o Síndico General Adjunto de la Sindicatura General de la Nación; Presidente o Auditor General de la Auditoría General de la Nación; autoridad superior de un ente regulador o de los demás órganos que integran los sistemas de control del sector público nacional; miembros de organismos jurisdiccionales administrativos, o personal de dicho organismo, con categoría no inferior a la de director o su equivalente.<br>
          i. Miembro del Consejo de la Magistratura de la Nación o del Jurado de Enjuiciamiento.<br>
          j. Embajador o Cónsul.<br>
          k. Personal de las Fuerzas Armadas, de la Policía Federal Argentina, de Gendarmería Nacional, de la Prefectura Naval Argentina, del Servicio Penitenciario Federal o de la Policía de Seguridad Aeroportuaria con jerarquía no menor de coronel o grado equivalente según la fuerza.<br>
          l. Rector, Decano o Secretario de las Universidades Nacionales.<br>
          m. Funcionario o empleado con categoría o función no inferior a la de Director General o Nacional, de la Administración Pública Nacional, centralizada o descentralizada, de entidades autárquicas, bancos y entidades financieras del sistema oficial, de las obras sociales administradas por el Estado, de empresas del Estado, las sociedades del Estado y el personal con similar categoría o función, designado a propuesta del Estado en sociedades de economía mixta, sociedades anónimas con participación estatal o en otros entes del sector público.<br>
          n. Funcionario o empleado público nacional encargado de otorgar habilitaciones administrativas, permisos o concesiones, para el ejercicio de cualquier actividad; como así también todo funcionario o empleado público encargado de controlar el funcionamiento de dichas actividades o de ejercer cualquier otro control en virtud de un poder de policía.<br>
          o. Funcionario público de algún organismo de control de servicios públicos, con categoría no inferior a la de Director General o Nacional.<br>
          p. Personal del Poder Legislativo de la Nación, con categoría no inferior a la de Director.<br>
          q. Personal del Poder Judicial de la Nación o del Ministerio Público de la Nación, con categoría no inferior a Secretario.<br>
          r. Funcionario o empleado público que integre comisiones de adjudicación de licitaciones, de compra o de recepción de bienes, o participe en la toma de decisiones de licitaciones o compras.<br>
          s. Funcionario público responsable de administrar un patrimonio público o privado, o controlar o fiscalizar los ingresos públicos cualquiera fuera su naturaleza.<br>
          t. Director o Administrador de alguna entidad sometida al control externo del Honorable Congreso de la Nación, de conformidad con lo dispuesto en el artículo 120 de la Ley Nº 24.156.<br>
          <br>
          ARTÍCULO 3º.- PERSONAS EXPUESTAS POLITICAMENTE PROVINCIALES, MUNICIPALES Y DE LA CIUDAD AUTONOMA DE BUENOS AIRES.<br>
          a. Gobernador o Vicegobernador, Intendente o Vice-intendente, Jefe de Gobierno o Vicejefe de Gobierno.<br>
          b. Ministro de Gobierno, Secretario, Subsecretario, Ministro de los Tribunales Superiores de Justicia de las provincias o de la Ciudad Autónoma de Buenos Aires.<br>
          c. Juez o Secretario de los Poderes Judiciales Provinciales o de la Ciudad Autónoma de Buenos Aires.<br>
          d. Magistrado perteneciente al Ministerio Público, o su equivalente, en las provincias o en la Ciudad Autónoma de Buenos Aires.<br>
          e. Miembro del Consejo de la Magistratura o del Jurado de Enjuiciamiento, o su equivalente, de las Provincias o de la Ciudad Autónoma de Buenos Aires.<br>
          f. Defensor del Pueblo o Defensor del Pueblo Adjunto, en las Provincias o en la Ciudad Autónoma de Buenos Aires.<br>
          g. Jefe de Gabinete de Ministros, Ministro, Secretario o Subsecretario del Poder Ejecutivo de las Provincias o de la Ciudad Autónoma de Buenos Aires.<br>
          h. Legislador provincial, municipal o de la Ciudad Autónoma de Buenos Aires.<br>
          i. Máxima autoridad de los organismos de control o de los entes autárquicos provinciales, municipales o de la Ciudad Autónoma de Buenos Aires.<br>
          j. Máxima autoridad de las sociedades de propiedad de los estados provinciales, municipales o de la Ciudad Autónoma de Buenos Aires.<br>
          k. Rector, Decano o Secretario de universidades provinciales.<br>
          l. Funcionario o empleado público encargado de otorgar habilitaciones administrativas, permisos o concesiones, para el ejercicio de cualquier actividad; como así también todo funcionario o empleado público encargado de controlar el funcionamiento de dichas actividades o de ejercer cualquier otro control en virtud de un poder de policía.<br>
          m. Funcionario de organismos de control de los servicios públicos provinciales o de la Ciudad de Buenos Aires, con categoría no inferior a la de Director General o Provincial.<br>
          n. Funcionario o empleado público que integre comisiones de adjudicación de licitaciones, de compra o de recepción de bienes, o participe en la toma de decisiones de licitaciones o compras.<br>
          o. Funcionario público que tenga por función administrar un patrimonio público o privado, o controlar o fiscalizar los ingresos públicos cualquiera fuera su naturaleza.<br>
          <br>
          ARTÍCULO 4º.- OTRAS PERSONAS EXPUESTAS POLITICAMENTE.<br>
          a. Autoridad, apoderado, candidato o miembro relevante de partidos políticos o alianzas electorales, ya sea a nivel nacional o distrital, de conformidad con lo establecido en las Leyes N° 23.298 y N° 26.215.<br>
          b. Autoridad de los órganos de conducción de organizaciones sindicales y empresariales (cámaras, asociaciones y otras formas de agrupación corporativa). El alcance comprende a las personas humanas de las mencionadas organizaciones con capacidad de decisión, administración, control o disposición del patrimonio sindical.<br>
          c. Autoridad, representante legal o integrante de la Comisión Directiva de las obras sociales contempladas en la Ley Nº 23.660. El alcance comprende a las personas humanas de las mencionadas organizaciones con capacidad de decisión, administración, control o disposición del patrimonio de las obras sociales.<br>
          d. Las personas humanas con capacidad de decisión, administración, control o disposición del patrimonio de personas jurídicas privadas en los términos del 148 del Código Civil y Comercial de la Nación, que reciban fondos públicos destinados a terceros.<br>
          <br>
          ARTÍCULO 5º.- PERSONAS EXPUESTAS POLITICAMENTE POR CERCANÍA O AFINIDAD.<br>
          a. Cónyuge o conviviente reconocido legalmente.<br>
          b. Familiares en línea ascendente, descendente, y colateral hasta el tercer grado de consanguinidad o afinidad.<br>
          c. Personas allegadas o cercanas: debe entenderse como tales a aquellas personas públicas y comúnmente conocidas por su íntima asociación a la persona definida como Persona Expuesta Políticamente.<br>
          d. Personas con las cuales se hayan establecido relaciones jurídicas de negocios del tipo asociativa, aún de carácter informal, cualquiera fuese su naturaleza.<br>
          e. Toda otra relación o vínculo que por sus características y en función de un análisis basado en riesgo, a criterio del sujeto obligado, pueda resultar relevante.
        </p>
      </div>
    </Modal>
    <Modal headerText="Términos y Condiciones" v-if="showTermsModal"
      @close="showTermsModal = !showTermsModal">
      <div class="modal-body-container" slot="body">
        <p style="text-align: left; font-size: 11px; line-height: 1.2; letter-spacing: 0.5px;">
            <br><br>El/los firmantes al pie de la presente solicita/n la apertura o actualización de una cuenta comitente, quedando sujeta a aprobación por parte de ALFY Inversiones S.A. La cuenta comitente operará bajo las siguientes condiciones:
            <br><br>
            <br><br>1) Las firmas, domicilios y demás datos que se encuentran en este registro de clientes se consideran válidos y vigentes hasta tanto ALFY Inversiones S.A. reciba notificación en forma fehaciente de la modificación requerida, aun cuando la misma haya sido publicada y registrada en los organismos pertinentes. Asimismo, el cliente declara bajo juramento que la información detallada en los formularios que conforman el legajo, es fiel y completa expresión de la verdad.
            <br><br>2) ALFY Inversiones S.A. en su actuación como Agente registrado podrá realizar aquellas operaciones detalladas en los Capítulos IV y V del Título VI de las Normas N.T. 2013 y modificatorias, en Mercados autorizados por la Comisión Nacional de Valores.  Dichas operaciones, su liquidación, tenencias y acreencias serán a través del depósito colectivo de los títulos valores del comitente en el depositante del Agente de Caja de Valores. Sin perjuicio de esto, el cliente podrá administrar sus tenencias directamente en Caja de Valores.
            <br><br>3) ALFY Inversiones S.A. podrá realizar operaciones por tratativas directas o negociación bilateral no garantizada bajo las condiciones establecidas por los Mercados en que intervenga ALFY Inversiones S.A. y serán conforme lo establecido en el Titulo VI Capítulo V Artículo 3 del texto de las Normas N.T. 2013 y modificatorias.
            <br><br>4) El cliente declara conocer y aceptar las Circulares N° 808 del 17/08/2010, N° 820 del 14/03/2020 y la Circular del 04/12/2019 y modificatorias, del Mercado de Valores S.A (MAV) referidas a la negociación de cheques de pago diferido o pagaré bursátil.  Asimismo, declara conocer los riesgos de los distintos tipos de operaciones detalladas en las Circulares, y en caso de solicitar una operación de este tipo, informará a ALFY Inversiones S.A. el segmento donde se opere. ALFY Inversiones S.A. y MAV no asumen responsabilidad alguna respecto del crédito o solvencia de las partes.
            <br><br>5) En lo que respecta a operaciones del exterior, las mismas se ajustarán a lo establecido en las Normas N.T. 2013 y modificatorias. ALFY Inversiones S.A. podrá realizar operaciones de compra y/o venta de instrumentos financieros en el exterior por cuentas de titularidad de la sociedad y a pedido del cliente, siempre que cuenten con autorización por parte de Comisiones de Valores u otros organismos de control extranjeros, que correspondan a países incluidos dentro del listado de países cooperadores previstos en el artículo 2º del inciso b) del Decreto Nº 589/2013, para ser comercializados en esas jurisdicciones a inversores, acorde al perfil de riesgo del cliente. Dichas operaciones no constituyen una orden para el Agente, en calidad de tal, sino como mandatario del ordenante. El cliente declara conocer que ALFY Inversiones S.A. ejecutará dichas órdenes a través de un bróker del exterior a elección del agente, y que la operación resultante no se encuentra garantizada por BYMA ni por ningún otro Mercado de los autorizados por la Comisión Nacional de Valores, y que la misma será cumplida por terceros no sujetos al control de la mencionada Comisión. Es por este motivo que estas operaciones son reservadas en forma exclusiva a Inversores Calificados. Por último, el cliente autoriza a ALFY Inversiones S.A., a mantener en custodia los títulos de su propiedad en cuentas del exterior registradas a nombre de la firma, con el objeto de agilizar la operatoria de referencia.
            <br><br>6) El cliente deberá identificar el riesgo que desea afrontar en el Perfil de Riesgo del Inversor. Cuando la operatoria a realizarse en la cuenta comitente no esté incluida en el nivel de riesgo elegido, ALFY Inversiones S.A. deberá contar con previa autorización por escrito del cliente o su convalidación fehaciente. Asimismo, el cliente declara conocer los riesgos inherentes de mercado, entendiendo que los mismos comprenden: riesgo de variación de precios de los activos, riesgo de liquidez, riesgo de crédito del emisor (privado o público) o de incumplimiento de pago, riesgo cambiario o de moneda y riesgo soberano, incluyendo el riesgo de cambios regulatorios o fiscales.
            <br><br>7) El cliente manifiesta que las instrucciones que imparta a ALFY Inversiones S.A., se emitirán cumpliendo alguno de los siguientes medios o modalidades de contacto que ALFY habilite a tal fin, tales como: presencial, internet, teléfono, correo electrónico, redes privadas de comunicación y cualquier otro que pudiera surgir en el futuro. La instrucción impartida o la confirmación específica tendrá validez diaria. Asimismo, el cliente podrá otorgar a ALFY Inversiones un Mandato de Administración Discrecional Total o Parcial para que actúe en su nombre administrando sus inversiones y tenencias.
            <br><br>8) El cliente conserva la facultad de otorgar y/o revocar el Mandato de Administración Discrecional Total o Parcial que otorgue voluntariamente al Agente para que actúe en su nombre. La ausencia de dicho Mandato hace presumir, salvo prueba en contrario, que las operaciones realizadas por el Agente no contaron con el consentimiento del cliente.
            <br><br>9) En el caso de que la cuenta comitente arroje saldos deudores, tanto en pesos como en otras monedas, según lo establecido en el Titulo VII Capitulo II Artículo 11 del texto de las Normas N.T. 2013 y modificatorias, se autoriza a ALFY Inversiones S.A. a cobrar recargos sobre los saldos monetarios descubiertos, utilizando como referencia la tasa de caución tomadora para el plazo de 7 días, más impuestos y gastos inherentes a dicha operatoria. Esta autorización también tendrá vigencia en el caso de que dichos saldos deudores se originen en gastos debitados por el Agente incluidos en la Tabla de Aranceles y Comisiones. Sin perjuicio de esto, ALFY Inversiones podrá ejecutar en forma compulsiva activos de la cartera del cliente deudor, hasta la concurrencia de la deuda.
            <br><br>10) Los saldos líquidos provenientes de operaciones instruidas por el cliente en forma específica, sólo serán reinvertidos a su solicitud y se autoriza al Agente a que los mantenga en el giro operativo de su actividad como Agente. En caso de ser solicitados en forma expresa por el cliente, los fondos líquidos serán transferidos a las cuentas bancarias declaradas en el acto de apertura de cuenta o informadas con posterioridad. En el marco de la actuación conforme el mandato de Administración Discrecional Total o Parcial y sin perjuicio de lo establecido en el Titulo VII, Capitulo II, Artículo 4 del texto de las Normas N.T. 2013, el administrador idóneo, invertirá los saldos líquidos cuando oportunamente lo considere, siempre priorizando el beneficio del cliente y dando cumplimiento a la estrategia elegida para dicha cuenta.
            <br><br>11) El cliente tiene derecho a solicitar el retiro de los saldos monetarios disponibles en su cuenta comitente, incluidas acreencias depositadas en su subcuenta comitente abierta en el Agente de Deposito Colectivo, atendiendo a las normas vigentes en relación a los retiros de fondos, y en los días y horarios en que ALFY Inversiones S.A. preste sus servicios. El cliente podrá completar el Instructivo Permanente para transferencias de fondos a cuentas de misma titularidad, en cuyo caso, deberá solicitar las mismas a través de alguna de las direcciones de mail declaradas en el formulario de apertura o actualización de cuenta.
            <br><br>12) ALFY Inversiones S.A. presta el servicio de cobro de dividendos, rentas, amortizaciones, etc., de títulos valores como así también suscripciones, prorrateos y en general todo tipo de servicios que hacen a la actividad, sin responsabilidad alguna en caso de omisión por parte del Agente pagador de los servicios antes mencionados.
            <br><br>13) El cliente toma conocimiento que podrá consultar a ALFY Inversiones S.A. si la operatoria realizada en su cuenta comitente tiene garantía de algún Mercado autorizado por la Comisión Nacional de Valores o Cámara Compensadora en su caso. Dicha situación estará expresada en el boleto de la operación concertada.
            <br><br>14) ALFY Inversiones S.A. no asegura rendimientos de ningún tipo y cuantía ya que las inversiones están sujetas a las fluctuaciones de las condiciones y precios de mercado. Asimismo, en ningún caso, se garantiza la protección del valor aportado a la cuenta comitente.
            <br><br>15) En virtud del Régimen Informativo con Clientes, según el Título VII, Capítulo II, Artículo 17 de las Normas NT 2013 de la Comisión Nacional de Valores, el agente enviará un mail de notificación automático a la dirección de correo electrónico declarada por el/ los firmante/s al finalizar cada día en que se produzcan operaciones en la cuenta comitente, con un detalle de las mismas.
            <br><br>16) El cliente declara bajo juramento, a los efectos de dar cumplimiento a la normativa vigente en materia de Prevención del Lavado de Dinero y Financiación del Terrorismo dictada por la UIF (Unidad de Información Financiera) y la CNV (Comisión Nacional de Valores), que la totalidad de los fondos y valores utilizados para realizar transacciones a través de ALFY Inversiones S.A. son de origen lícito. Asimismo, el cliente se compromete a aportar toda la información y/o documentación que en el futuro le sea requerida por ALFY Inversiones S.A. en cumplimiento de la citada normativa.
            <br><br>17) El cliente autoriza a ALFY Inversiones S.A. a entregar a las entidades financieras intervinientes en la liquidación de las operaciones cursadas por el mismo y a los organismos de contralor, tanto locales como internacionales, documentación requerida por ellos en atención al cumplimiento de la normativa vigente, en materia de Prevención del Lavado de Dinero y Financiación del Terrorismo o bien a regulaciones específicas que deba cumplimentar el Agente. La documentación a entregar será según cada caso, la aportada por el cliente a ALFY Inversiones S.A., en virtud de esta solicitud de apertura de cuenta comitente o bien con posterioridad a ella en el transcurso de la relación comercial.
            <br><br>18) En caso de que el cliente solicite el cierre de su cuenta comitente, deberá notificar a ALFY Inversiones S.A. en forma expresa. Sin perjuicio de ello ALFY Inversiones S.A. se reserva el derecho de proceder al cierre de la cuenta ante el incumplimiento por parte del cliente de la normativa de Prevención del Lavado de Dinero y Financiación del Terrorismo, así como por asuntos de índole comercial en los que el Agente crea conveniente discontinuar el vínculo con el cliente. En ambos casos ALFY Inversiones S.A. notificará al cliente el cierre de su cuenta. Asimismo, ALFY Inversiones S.A. podrá, sin notificar al cliente, cerrar cuentas inactivas y/o sin posición Para proceder al cierre de la cuenta, la misma no deberá registrar saldos monetarios ni tenencias de títulos valores. Para ello, ALFY Inversiones S.A. se limitará a liquidar operaciones pendientes y transferirá al cliente tenencias y saldos resultantes en su cuenta comitente sin que esta decisión otorgue al mismo derecho de exigir compensación alguna.
            <br><br>19) El cliente manifiesta conocer los riesgos que asume ante posibles incumplimientos por parte del Agente en materia de custodia, operatoria y liquidación de operaciones, así como también los organismos a los cuales deberá dirigirse para efectuar el reclamo pertinente.
            <br><br>20) El cliente durante todo el vínculo comercial con ALFY Inversiones. S.A., podrá acercar consultas o inquietudes al Agente a través del personal idóneo con el que se relacione en forma habitual. Asimismo, podrá formular eventuales reclamos, directamente al Responsable de Relaciones con el Público, a la dirección de mail responsable.cliente@alfyinversiones.com.ar. El nombre de dicho funcionario estará disponible en la página web, y el cliente podrá solicitar una reunión en forma personal si lo considera conveniente.
            <br><br>21) El cliente se notifica que los costos intervinientes vigentes, Tabla de Aranceles, están disponibles para consulta, en el sitio oficial de la compañía www.alfyinversiones.com.ar.
            <br><br>22) ALFY Inversiones S.A. en su carácter de Agente registrado en la Comisión Nacional de Valores, se compromete a cumplir con lo establecido en el Título VII, Capítulo II, Artículo 16 del Texto de Normas N.T. 2013 referido a las obligaciones del Agente.
            <br><br>23) El cliente autoriza expresamente a ALFY Inversiones S.A. a compartir su legajo de cliente, así como la información y documentación en él contenido, con aquellos Agentes Registrados que sean Sujetos Obligados ante UIF que formen parte del Grupo ó con los que ALFY Inversiones S.A. haya celebrado un acuerdo a tales efectos.
            <br><br>24) El cliente manifiesta que suscribió convenio con el siguiente AAGI: ________________________________________________
            <br><br>Asimismo, el cliente se compromete a informar en forma fehaciente a ALFY Inversiones en caso que la información aquí declarada sufra modificaciones.
            <br><br>25) Dado que ALFY celebró acuerdo con RENAPER, organismo que ofrece el servicio de validación de datos personales, el cliente, en su carácter de titular de los datos presta consentimiento para que “ALFY Inversiones S.A” en su carácter de cesionario confronte sus datos personales con la base de datos del RENAPER, conforme a las siguientes especificaciones:
            <br><br>    a) En cuanto a datos autorizados, el presente consentimiento alcanza a los incluidos en su DNI en confronte con lo que informa el web service del RENAPER.
            <br><br>    En lo que respecta al tratamiento;
            <br><br>    b) Los datos serán tratados con la exclusiva finalidad de validar la identidad del cliente y verificar la vigencia de su DNI para ALFY
            <br><br>    c) Los datos son facilitados con carácter obligatorio, por cuanto es imprescindible identificar fehacientemente al titular, para asegurar el correcto proceso de identificación.
            <br><br>    d) El titular de los datos podrá ejercer los derechos de acceso, rectificación y supresión de sus datos en cualquier momento y a su sola solicitud ante el RENAPER.
            <br><br>    e) En cumplimiento de la Resolución AAIP Nº 14/2018, informamos que la Agencia de Acceso a la Información Pública, en su carácter de Órgano de Control de la Ley N° 25.326, tiene la atribución de atender las denuncias y reclamos que interpongan quienes resulten afectados en sus derechos por incumplimiento de las normas vigentes en materia de protección de datos personales.
            <br><br>26) Se podrá acceder a información y normativa relativa a la actividad del agente en las siguientes páginas web:
            <br><br>    · ALFY Inversiones S.A. (www.alfyinversiones.com.ar)
            <br><br>    · Comisión Nacional de Valores (www.cnv.gov.ar)
            <br><br>    · Mercado de Valores de Buenos Aires (www.merval.sba.com.ar)
            <br><br>    · Bolsas y Mercados Argentinos (www.byma.com.ar)
            <br><br>    · Caja de Valores S.A. (www.cajval.sba.com.ar)
            <br><br>    · Bolsa de Comercio de Buenos Aires (www.bcba.sba.com.ar)
            <br><br>    · Ministerio de Economía y Finanzas Públicas ( www.mecon.gov.ar)
            <br><br>    · Banco Central de la República Argentina (www.bcra.gov.ar)
            <br><br>27) La relación entre las partes se regirá por la Ley de Mercado de Capitales Nº 26.831, el Decreto 1023/11, el texto de Normas N.T.2013, las normas específicas de los Mercados autorizados por la Comisión Nacional de Valores en que opere el agente y todas aquellas que sean dictadas en el futuro. Ante diferencias de criterios, el cliente y ALFY Inversiones S.A. se someterán a la jurisdicción de los tribunales ordinarios de la Ciudad Autónoma de Buenos Aires.
        </p>
      </div>
    </Modal>
    <Modal headerText="NIF/NIT/CUIL" v-if="showFiscalCountryModal">
      <div class="modal-body-container" slot="body">
        <p style="text-align: left;">Completá tu número de identificación fiscal o tributaria:</p>
        <p style="text-align: left; font-weight: 700;">{{countryChoices[Number(lastChosenFiscalCountry) - 1].name}}</p>
        <input @keydown.enter="completedNif" id="id-number"
          type="number" placeholder="NIF/NIT/CUIL" v-model="nifNumber" />
        <p v-if="errorNif" class="error-message">{{errorNif}}</p>
      </div>
      <div class="modal-footer-container" slot="footer">
        <button class="modal-default-button" @click="completedNif">
          OK
        </button>
        <button class="modal-default-button" style="background: none; color: #333; display: inline-block; margin-top: 0; border: none; height: auto; padding: 0;" @click="showFiscalCountryModal = !showFiscalCountryModal">
          Cancelar
        </button>
      </div>
    </Modal>
    <Modal headerText="" v-if="error"
      @close="error = ''">
      <div class="modal-body-container" slot="body">
        <p>{{error}}</p>
      </div>
    </Modal>
    <div class="mounted-button">
      <button class="container" @click="updateFiscalData">Continuar</button>
    </div>
  </div>
</template>

<script>
import axios from 'axios';
import CONSTANTS from '@/constants';
import Modal from '@/components/Modal.vue';

export default {
  name: 'additional-information',
  components: {
    Modal,
  },
  data() {
    return {
      activityTypeTitle: '¿Cuál es tu Rubro o Actividad?',
      isRelationshipActive: true,
      isWorkTypeActive: false,
      isWorkIndustryActive: false,
      isPEPActive: false,
      isFiscalCountryActive: false,
      isCellPhoneActive: false,
      RELATIONSHIP: 0,
      WORK_TYPE: 1,
      WORK_INDUSTRY: 2,
      PEP: 3,
      FISCAL_COUNTRY: 4,
      CELL_PHONE: 5,
      jobSearchField: '',
      countrySearchField: '',
      cellphoneCode: '',
      cellphoneNumber: '',
      relationshipTypes: [
        { key: 'SOLTERO', value: 'Soltero(a)' },
        { key: 'CASADO', value: 'Casado(a)' },
        { key: 'DIVORCIADO', value: 'Divorciado(a)' },
        { key: 'VIUDO', value: 'Viudo(a)' },
      ],
      dependancyRelationship: [
        { key: 'YES', value: 'Si' },
        { key: 'NO_STUDENT', value: 'No, soy estudiante' },
        { key: 'NO_INDEPENDENT', value: 'No, soy independiente' },
        { key: 'NO_RETIRED', value: 'No, soy jubilado' },
        { key: 'NO_JOB', value: 'No, estoy sin empleo actual' },
      ],
      pepChoices: [
        { key: 'NO', value: 'No' },
        { key: 'YES_DIRECTLY', value: 'Si, directamente' },
        { key: 'YES_FAMILY', value: 'Si, por vínculo familiar' },
      ],
      countryChoices: [],
      filteredCountryChoices: [],
      filteredJobChoices: [],
      jobChoices: [],
      showPepModal: false,
      showFiscalCountryModal: false,
      showTermsModal: false,
      acceptedTermsAndCondition: false,
      chosenRelationshipType: '',
      chosenDependancy: '',
      chosenPep: '',
      lastChosenFiscalCountry: 0,
      nifNumber: '',
      chosenFiscalCountries: {},
      chosenJobs: [],
      maxLengthCellphone: 10,
      maxLengthCellphoneCode: 4,
      errorNif: '',
      error: '',
    };
  },
  props: {
    token: String,
    loggedIn: Boolean,
    user: Object,
    userData: Object,
    screen: Number,
  },
  computed: {
    getCompletedCellphone() {
      if (!(this.cellphoneCode && this.cellphoneNumber && this.cellphoneCode.length > 1 && this.cellphoneNumber.length >= 8)) return false;
      return true;
    },
  },
  watch: {
    jobSearchField() {
      this.filterByJobs();
    },
    countrySearchField() {
      this.filterByFiscalCountries();
    },
    /* lastChosenFiscalCountry(val) {
      if (val === '') {
        return;
      }
      if (val === 1) {
        if (!('1' in this.chosenFiscalCountries)) {
          this.chosenFiscalCountries['1'] = this.$props.userData.cuil;
        }
        return;
      }
      this.showFiscalCountryModal = true;
    }, */
  },
  methods: {
    isNumber(evt) {
      const charCode = (evt.which) ? evt.which : evt.keyCode;
      if (charCode > 57 || charCode < 48) {
        evt.preventDefault();
        return false;
      }
      return true;
    },
    filterByJobs() {
      let filtered = this.jobChoices;
      if (this.jobSearchField) {
        filtered = this.jobChoices.filter(
          m => m.name.toLowerCase().indexOf(this.jobSearchField.toLowerCase()) > -1,
        );
      }
      filtered = filtered.filter(
        m => !this.chosenJobs.includes(m.id),
      );
      filtered = filtered.filter(
        m => !(m.name === 'Desocupado' || m.name === 'Jubilado' || m.name === 'Estudiante'),
      );
      // No se eligió el "Otros" (47) y el array está vacío
      const otrosInList = this.jobChoices.filter(m => m.name === 'Otros');
      if (otrosInList.length > 0) {
        if (filtered.length === 0 && !this.chosenJobs.includes(otrosInList[0].id)) {
          filtered = this.jobChoices.filter(
            m => m.name === 'Otros',
          );
        }
      }
      this.filteredJobChoices = filtered;
    },
    filterByFiscalCountries() {
      let filtered = this.countryChoices;
      if (this.countrySearchField) {
        filtered = this.countryChoices.filter(
          m => m.name.toLowerCase().indexOf(this.countrySearchField.toLowerCase()) > -1,
        );
      }
      filtered = filtered.filter(
        m => !(m.code in this.chosenFiscalCountries),
      );
      this.filteredCountryChoices = filtered;
    },
    completedNif() {
      this.errorNif = '';
      if (this.nifNumber === undefined || this.nifNumber === null || this.nifNumber === '') {
        this.errorNif = 'Falta ingresar tu número NIF';
        return;
      }
      this.chosenFiscalCountries[this.lastChosenFiscalCountry] = this.nifNumber;
      this.nifNumber = '';
      this.showFiscalCountryModal = false;
      this.filterByFiscalCountries();
    },
    relationshipTypeChosen(key) {
      this.chosenRelationshipType = key;
      this.closeAccordion(this.RELATIONSHIP);
      this.openAccordion(this.WORK_TYPE);
      setTimeout(document.getElementById('relationship-accordion').scrollIntoView({ behavior: 'smooth' }), 1000);
    },
    dependancyRelationshipChosen(key) {
      this.chosenDependancy = key;
      this.closeAccordion(this.WORK_TYPE);
      this.chosenJobs = [];
      if (key !== 'YES' && key !== 'NO_INDEPENDENT') {
        let jobObject;
        switch (key) {
          case 'NO_JOB':
            jobObject = this.jobChoices.find(o => o.name === 'Desocupado');
            if (jobObject !== undefined) {
              this.chosenJobs.push(jobObject.id);
            }
            break;
          case 'NO_RETIRED':
            jobObject = this.jobChoices.find(o => o.name === 'Jubilado');
            if (jobObject !== undefined) {
              this.chosenJobs.push(jobObject.id);
            }
            break;
          case 'NO_STUDENT':
            jobObject = this.jobChoices.find(o => o.name === 'Estudiante');
            if (jobObject !== undefined) {
              this.chosenJobs.push(jobObject.id);
            }
            break;
          default:
            break;
        }
        this.openAccordion(this.PEP);
      } else {
        if (key === 'YES') {
          this.activityTypeTitle = '¿Cuál es el Rubro o Actividad de tu empleador?';
        } else {
          this.activityTypeTitle = '¿Cuál es tu Rubro o Actividad?';
        }
        this.openAccordion(this.WORK_INDUSTRY);
      }
      setTimeout(document.getElementById('dependancy-type-accordion').scrollIntoView({ behavior: 'smooth' }), 1000);
    },
    jobChosen(key) {
      this.chosenJobs.push(key);
      this.filterByJobs();
      this.closeAccordion(this.WORK_INDUSTRY);
      this.openAccordion(this.PEP);
      setTimeout(document.getElementById('dependancy-accordion').scrollIntoView({ behavior: 'smooth' }), 1000);
    },
    pepChosen(key) {
      this.chosenPep = key;
      this.closeAccordion(this.PEP);
      this.openAccordion(this.FISCAL_COUNTRY);
      setTimeout(document.getElementById('pep-accordion').scrollIntoView({ behavior: 'smooth' }), 1000);
    },
    fiscalCountryChosen(key) {
      this.lastChosenFiscalCountry = key;
      if (key === '') {
        return;
      }
      if (key === 1) {
        if (!('1' in this.chosenFiscalCountries) && this.$props.userData.cuil !== '') {
          this.chosenFiscalCountries['1'] = this.$props.userData.cuil;
          this.filterByFiscalCountries();
          this.closeAccordion(this.FISCAL_COUNTRY);
          this.openAccordion(this.CELL_PHONE);
          return;
        }
      }
      this.showFiscalCountryModal = true;
      this.closeAccordion(this.FISCAL_COUNTRY);
      this.openAccordion(this.CELL_PHONE);
      setTimeout(document.getElementById('fiscal-country-accordion').scrollIntoView({ behavior: 'smooth' }), 1000);
    },
    openAccordion(type) {
      switch (type) {
        case this.RELATIONSHIP:
          this.isRelationshipActive = true;
          break;
        case this.WORK_TYPE:
          this.isWorkTypeActive = true;
          break;
        case this.WORK_INDUSTRY:
          this.isWorkIndustryActive = true;
          break;
        case this.PEP:
          this.isPEPActive = true;
          break;
        case this.FISCAL_COUNTRY:
          this.isFiscalCountryActive = true;
          break;
        case this.CELL_PHONE:
          this.isCellPhoneActive = true;
          break;
        default:
          break;
      }
    },
    closeAccordion(type) {
      switch (type) {
        case this.RELATIONSHIP:
          this.isRelationshipActive = false;
          break;
        case this.WORK_TYPE:
          this.isWorkTypeActive = false;
          break;
        case this.WORK_INDUSTRY:
          this.isWorkIndustryActive = false;
          break;
        case this.PEP:
          this.isPEPActive = false;
          break;
        case this.FISCAL_COUNTRY:
          this.isFiscalCountryActive = false;
          break;
        case this.CELL_PHONE:
          this.isCellPhoneActive = false;
          break;
        default:
          break;
      }
    },
    deleteJob(keyToDelete) {
      this.chosenJobs = this.chosenJobs.filter(key => key !== keyToDelete);
      this.filterByJobs();
    },
    deleteFiscalCountry(keyToDelete) {
      this.$delete(this.chosenFiscalCountries, keyToDelete);
      this.filterByFiscalCountries();
    },
    updateFiscalData() {
      if (!this.isDataSelected()) {
        this.error = 'Verificá haber completado todos los campos antes de avanzar';
        return;
      }
      if (Object.entries(this.chosenFiscalCountries).length === 0 && this.chosenFiscalCountries.constructor === Object) {
        this.error = 'Por favor, seleccioná el país de tu residencia fiscal';
        return;
      }
      if (this.chosenJobs.length === 0) {
        this.error = 'Por favor, seleccioná tu rubro o actividad';
        return;
      }
      if (!this.acceptedTermsAndCondition) {
        this.error = 'Por favor, aceptá los términos y condiciones para completar tu apertura de cuenta';
        return;
      }
      this.setIsLoading();
      const chosenFiscalCountriesEntries = Object.entries(this.chosenFiscalCountries);
      const chosenFiscalCountriesMap = chosenFiscalCountriesEntries.map(x => ({ country_code: Number(x[0]), fiscal_id: x[1] }));
      const data = JSON.stringify(chosenFiscalCountriesMap);
      console.log(data);
      const options = {
        method: 'POST',
        data,
        headers: { 'Content-Type': 'application/json', Authorization: `Token ${this.$props.token}` },
        url: `${CONSTANTS.BACKEND_URL}${CONSTANTS.API_URL}/fiscal-data/`,
      };
      console.log(options);
      axios(options)
        .then((/* result */) => {
          this.updateUserActivities();
        })
        .catch((error) => {
          console.log(error);
          this.$rollbar.error(error);
          let email = '';
          if (localStorage.getItem('email')) {
            email = JSON.parse(localStorage.getItem('email'));
          }
          this.$rollbar.info('updateFiscalData', { loggedIn: this.$props.loggedIn, email });
          console.log(error.response);
        });
    },
    updateUserActivities() {
      const chosenJobsMap = this.chosenJobs.map(x => ({ activity: x }));
      const data = JSON.stringify(chosenJobsMap);
      console.log(data);
      const options = {
        method: 'POST',
        data,
        headers: { 'Content-Type': 'application/json', Authorization: `Token ${this.$props.token}` },
        url: `${CONSTANTS.BACKEND_URL}${CONSTANTS.API_URL}/user-activities/`,
      };
      console.log(options);
      axios(options)
        .then((/* result */) => {
          this.updateUserData();
        })
        .catch((error) => {
          console.log(error);
          this.$rollbar.error(error);
          let email = '';
          if (localStorage.getItem('email')) {
            email = JSON.parse(localStorage.getItem('email'));
          }
          this.$rollbar.info('updateUserActivities', { loggedIn: this.$props.loggedIn, email });
          console.log(error.response);
        });
    },
    updateUserData() {
      const data = JSON.stringify({
        telephone: `${this.cellphoneCode}${this.cellphoneNumber}`,
        marital_status: this.chosenRelationshipType,
        dependency_relationship: this.chosenDependancy,
        // job: Number(this.chosenJob),
        pep: this.chosenPep,
        accepted_term_conditions: this.acceptedTermsAndCondition,
      });
      const options = {
        method: 'POST',
        data,
        headers: { 'Content-Type': 'application/json', Authorization: `Token ${this.$props.token}` },
        url: `${CONSTANTS.BACKEND_URL}${CONSTANTS.API_URL}/user/profile/`,
      };
      // console.log(options);
      axios(options)
        .then((result) => {
          let email = '';
          if (localStorage.getItem('email')) {
            email = JSON.parse(localStorage.getItem('email'));
          }
          window.gtag('event', 'submit', {
            event_category: 'paso4',
            event_label: email,
          });
          const user = result.data;
          this.$emit('user-updated', user);
          this.$emit('advance-screen', 4);
        })
        .catch((error) => {
          console.log(error);
          this.$rollbar.error(error);
          let email = '';
          if (localStorage.getItem('email')) {
            email = JSON.parse(localStorage.getItem('email'));
          }
          this.$rollbar.info('updateUserData', { loggedIn: this.$props.loggedIn, email });
          console.log(error.response);
        });
    },
    setIsLoading(loading = true) {
      this.$emit('is-loading', loading);
    },
    isDataSelected() {
      if (!(
        this.chosenRelationshipType
        && this.chosenDependancy
        // && ((this.chosenDependancy === 'YES' && this.chosenJob) || (this.chosenDependancy === 'NO_INDEPENDENT' && this.chosenJob) || (this.chosenDependancy !== 'YES' && this.chosenDependancy !== 'NO_INDEPENDENT' && !this.chosenJob))
        // && this.chosenJob
        && this.chosenPep
        && this.cellphoneNumber
        && this.cellphoneCode
      )) {
        // console.log(this.chosenRelationshipType);
        // console.log(this.chosenDependancy);
        // console.log(this.chosenPep);
        // console.log(this.cellphoneNumber);
        // console.log(this.cellphoneCode);
        // console.log((this.chosenDependancy === 'YES' && this.chosenJob));
        return false;
      }
      return true;
    },
  },
  mounted() {
    /* We redirect to log in screen if not logged in */
    if (!this.$props.loggedIn) this.$router.push({ name: 'basic-info' });
    if (this.$props.screen !== 3) this.$emit('advance-screen-protect', this.$props.screen);
    window.gtag('config', 'UA-140392151-1', {
      page_title: 'paso4',
      page_path: '/additional',
    });
    const countryOptions = {
      method: 'GET',
      headers: { 'Content-Type': 'application/json', Authorization: `Token ${this.$props.token}` },
      url: `${CONSTANTS.BACKEND_URL}${CONSTANTS.API_URL}/countries/`,
    };
    axios(countryOptions)
      .then((result) => {
        this.countryChoices = result.data.results;
        this.filterByFiscalCountries();
      })
      .catch((error) => {
        if (error.response.status === 401) {
          console.log('Unauthorized');
        }
        console.log(error.response);
      });
    const activitiesOptions = {
      method: 'GET',
      headers: { 'Content-Type': 'application/json', Authorization: `Token ${this.$props.token}` },
      url: `${CONSTANTS.BACKEND_URL}${CONSTANTS.API_URL}/activities/`,
    };
    axios(activitiesOptions)
      .then((result) => {
        const newActivities = result.data.results.filter((obj, i) => i > 62);
        this.jobChoices = newActivities;
        this.filterByJobs();
      })
      .catch((error) => {
        if (error.response.status === 401) {
          console.log('Unauthorized');
        }
        console.log(error.response);
      });
  },
};
</script>

<style lang="scss">
@import '../assets/css/variables.scss';

.additional-information {
  @media screen and (min-width: $break-sm) {
    .mounted-button {
      margin: -60px auto 0px;
      position: relative;
      background-color: #fbfbfb;
      width: 80%;
      padding: 7px 0;
    }
  }
}

.additional-information .information-section {
  @media screen and (min-width: $break-sm) {
    height: 273px;
    margin-bottom: 60px;
    overflow-y: scroll;
    &::-webkit-scrollbar {
      width: 0.5em;
      border-radius: 10px;
      background-color: #c6c6c6;
    }
    &::-webkit-scrollbar-track {
      border-radius: 10px;
      background-color: #c6c6c6;
    }
    &::-webkit-scrollbar-thumb {
      border-radius: 10px;
      background-color: #868686;
      outline: 1px solid #868686;
    }
  }
}
.accordion-section {
  border: solid #b1bfc4;
  border-width: 0 0 1px;
  text-align: left;
}
.accordion-section:last-child {
    border: none;
}
.accordion-section.hidden {
  display: none;
}
.accordion-tooltip {
  text-decoration: none;
  font-size: 15px;
  font-weight: 400;
  display: table;
  padding: 20px 2px;
  width: 100%;
  color: $dark-green;
  box-sizing: border-box;
}
a.accordion-tooltip:hover .accordion-text-cell, .accordion-section.active .accordion-text-cell {
  color: #040d14;
}
a.accordion-tooltip .accordion-text-cell.selected, .accordion-section.active .accordion-text-cell.selected {
  color: #00d667;
}
.accordion-link {
  color: #006bab;
  font-size: 11px;
}
.accordion-content-list li.selected {
    font-weight: 600;
}
.accordion-text-cell {
  color: #b1bfc4;
  line-height: 1.3;
}
.table-cell-vmid {
  display: table-cell;
  vertical-align: middle;
}
.accordion-section.active .accordion-dropdown-icon {
  background-image: url(
data:image/svg+xml;base64,PHN2ZyBoZWlnaHQ9JzMwMHB4JyB3aWR0aD0nMzAwcHgnICBmaWxsPSIjMDBkNjY3IiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIiB2ZXJzaW9uPSIxLjAiIHg9IjBweCIgeT0iMHB4IiB2aWV3Qm94PSIwIDAgMTAwIDEwMCIgZW5hYmxlLWJhY2tncm91bmQ9Im5ldyAwIDAgMTAwIDEwMCIgeG1sOnNwYWNlPSJwcmVzZXJ2ZSI+PGc+PHBhdGggZD0iTTQ3LDczLjdMNi41LDMzLjJDNC44LDMxLjUsNC41LDI4LjgsNiwyN2MxLjctMi4xLDQuOC0yLjIsNi43LTAuM0w0Nyw2MWMxLjYsMS42LDQuMywxLjYsNS45LDBsMzQuMy0zNC4zICAgYzEuOC0xLjgsNC42LTEuOCw2LjQsMGMxLjgsMS44LDEuOCw0LjYsMCw2LjRMNTMsNzMuN0M1MS4zLDc1LjQsNDguNyw3NS40LDQ3LDczLjd6Ij48L3BhdGg+PC9nPjwvc3ZnPg==
  );
  -moz-transform: scaleY(-1);
  -o-transform: scaleY(-1);
  -webkit-transform: scaleY(-1);
  transform: scaleY(-1);
  filter: FlipV;
  -ms-filter: "FlipV";
}
.accordion-dropdown-icon {
  background-image: url(
data:image/svg+xml;base64,PHN2ZyBoZWlnaHQ9JzMwMHB4JyB3aWR0aD0nMzAwcHgnICBmaWxsPSIjMDAwMDAwIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIiB2ZXJzaW9uPSIxLjAiIHg9IjBweCIgeT0iMHB4IiB2aWV3Qm94PSIwIDAgMTAwIDEwMCIgZW5hYmxlLWJhY2tncm91bmQ9Im5ldyAwIDAgMTAwIDEwMCIgeG1sOnNwYWNlPSJwcmVzZXJ2ZSI+PGc+PHBhdGggZD0iTTQ3LDczLjdMNi41LDMzLjJDNC44LDMxLjUsNC41LDI4LjgsNiwyN2MxLjctMi4xLDQuOC0yLjIsNi43LTAuM0w0Nyw2MWMxLjYsMS42LDQuMywxLjYsNS45LDBsMzQuMy0zNC4zICAgYzEuOC0xLjgsNC42LTEuOCw2LjQsMGMxLjgsMS44LDEuOCw0LjYsMCw2LjRMNTMsNzMuN0M1MS4zLDc1LjQsNDguNyw3NS40LDQ3LDczLjd6Ij48L3BhdGg+PC9nPjwvc3ZnPg==
  );
  background-size: 19px;
  background-repeat: no-repeat;
  background-position-x: 100%;
  float: right;
  height: 16px;
  margin-left: 3px;
  overflow: hidden;
  width: 25px;
}
.accordion-tooltip:hover .accordion-dropdown-icon {
  background-size: 21px;
}
.accordion-animation-padding {
  padding: 0 20px;
}

.accordion-content {
  font-size: 14px;
  line-height: 16px;
  max-height: 0;
  overflow: hidden;
  padding: 0;
  -webkit-transition: all 0.4s ease-in-out;
  -o-transition: all 0.4s ease-in-out;
  transition: all 0.4s ease-in-out;
}
.accordion-section.active .accordion-content {
  max-height: none;
  padding: 10px 0 30px;
  &.telephone-content {
    padding: 0px;
  }
}
.accordion-content-list li {
  padding: 8px 0;
  cursor: pointer;
}
.accordion-content-list.fiscal-countries-chosen li, .accordion-content-list.jobs-chosen li {
  cursor: auto;
}
.accordion-content-list.jobs-chosen li {
  font-size: 11px;
}
/* .accordion-content-list li:not(:last-child) {
  border-bottom: solid 1px #CCC;
} */
#job-search-field {
  margin-top: 0;
}
.accordion-input-fields {
  font-size: 14px;
  height: 33px;
  padding: 0 8px;
}
.cellphone-fields {
  width: 140px;
  display: inline-block;
  min-width: unset;
}
#cellphone-code-field {
  width: 80px;
  margin-right: 5px;
}
#terms-and-conditions {
  display: inline-block;
  width: auto;
  height: auto;
  margin-right: 5px;
}
.del {
  width: auto;
  padding: 5px 4px 4px 5px;
  display: inline-block;
  background-color: #333333;
  margin: 0;
  font-size: 8px;
  font-weight: 900;
  height: auto;
  line-height: 1;
  border: none;
  float: right;
  border-radius: 99px;
}
</style>
